import styled from 'styled-components'

export const InfoBox = styled.div`
  text-align: center;
  padding: 16px 15px 32px;

  p{
    font-family: 'Open Sans';
    font-weight: 400;
    font-size: 14px;
    line-height: 145%;
    text-align: center;
    color: #555;
    margin: 0px;
  }
`
export const Title = styled.h3`
  font-size: 24px;
  letter-spacing: 0.96px;
  font-weight: 700;
  color: #222;
  width: 100%;
  text-align: center;
  margin-bottom: 8px;
  padding: 0 24px;
`

export const Row = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: 25px;

  .solicitation-date-picker {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: left;
    padding: 0px 15px;
    border: 1px solid #999999;
    border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-border-radius: 4px;
    color: #555555;
    font-size: 14px;
    background-color: #fff;
    display: block;
  }

  .react-datepicker-popper {
    z-index: 2;
  }
`

export const Subtitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin-bottom: 20px;
`

export const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  div:nth-child(2) {
    margin-left: 25px;
  }
`

export const Label = styled.label`
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  color: #555;
`

export const DatePickerContainer = styled.div`
  position: relative;

  label {
    position: absolute;
    top: -12px;
    left: 14px;
    margin: 0px;
    background-color: #fff;
    color: #222;
    font-size: 12px;
    font-family: 'Open Sans';
    font-weight: 400;
    padding: 4px;
    z-index: 1;
  }
`

export const CalendarCaptions = styled.ul`
  list-style: none;
  padding: 0px;

  img {
    height: 20px;
    width: 20px;
    padding: 2px;
  }

  li {
    font-family: 'Open Sans';
    display: flex;
    margin: 8px 6px;
    font-size: 12px;
    font-weight: 400;
    line-height: 145%;
    color: #000;
    align-items: center;
    padding: 0px;
    gap: 4px;

    &.unavailable {
      color: #ccc;
    }
    &.scheduled {
      color: #FF8200;
    }
  }
`
